import {DeserializedRecord, deserializeItem, Deserializer, deserializeSingleRelationship, JSONAPIRecord, JSONAPISingleRelationship} from "./Helpers";


interface GermanStatutoryMedicalService extends DeserializedRecord {
    type: "german_statutory_medical_service";
    serviceText: string;
    serviceDescription?: string;
    billingCode: string;
    valuationInPoints?: number;
    valuationInCents?: number;
    version?: string;
}

interface GermanPrivateMedicalService extends DeserializedRecord {
    type: "german_private_medical_service";
    serviceText: string;
    serviceDescription?: string;
    billingCode: string;
    valuationInPoints?: number;
    valuationInCents?: number;
    chargeAmount: number;
    chargeMultiplier: number;
    chargeExplanation?: string;
}

type MedicalService = GermanStatutoryMedicalService | GermanPrivateMedicalService;
type MedicalBillingSubjectType = "MedicalBilling::GermanStatutoryMedicalService" | "MedicalBilling::GermanPrivateMedicalService" | string;

interface MedicalBilling extends DeserializedRecord {
    billingParty?: string;
    billingCapability?: string;
    billingConstraint?: string;
    abbreviationShort?: string;
    abbreviationLong?: string;
    subjectType: MedicalBillingSubjectType;
    subject?: MedicalService
}

interface MedicalBillingData extends JSONAPIRecord {
    relationships: {
        subject: JSONAPISingleRelationship;
    }
}


const deserializeMedicalBilling: Deserializer<MedicalBilling, MedicalBillingData> = (data, included) => {
  const subject = deserializeSingleRelationship<MedicalService>(data.relationships.subject, included);

  return {
    subject,
    ...deserializeItem(data)
  };
};

export {
  MedicalBilling,
  MedicalService,
  GermanPrivateMedicalService,
  GermanStatutoryMedicalService,
  deserializeMedicalBilling
};
